import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import { ChevronDown, Search } from "lucide-react";

export default function MultiSelectWithSearch({
  placeholder,
  children,
  showSearch = false,
  isErrorState = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredChildren = React.Children.toArray(children).filter((child) => {
    if (!child || !child.props || !child.props.children) return true;

    const childContent = Array.isArray(child.props.children)
      ? child.props.children.map((element) => {
          if (typeof element === 'string') return element;
          if (element.props && element.props.children) {
            return extractTextContent(element.props.children);
          }
          return '';
        }).join('')
      : extractTextContent(child.props.children);

    const contentString = String(childContent).toLowerCase();
    return !searchTerm || contentString.includes(searchTerm.toLowerCase());
  });

  function extractTextContent(children) {
    return React.Children.toArray(children).reduce((acc, child) => {
      if (typeof child === 'string') {
        return acc + child;
      } else if (child.type === 'span') {
        return acc + child.props.children;
      } else if (child.props && child.props.children) {
        return acc + extractTextContent(child.props.children);
      }
      return acc;
    }, '');
  }



  return (
    <div
      className={`docpro_dropdown_with_search_wrap ${isOpen ? "active" : ""}`}
      ref={dropdownRef}
    >
      <div
        className={classNames("docpro_dropdown_with_search_btn", {
          danger_alert: isErrorState,
        })}
        onClick={toggleDropdown}
      >
        {placeholder} <ChevronDown width={20} height={20} />
      </div>
      {isOpen && (
        <div
          className="docpro_dropdown_with_search_body custom-scroll"
          style={{ width: "100%" }}
        >
          {showSearch && (
            <div className="docpro_search_form">
              <input
                type="text"
                placeholder="Search"
                className="docpro_search_input"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <button type="button" className="docpro_search_btn">
                <Search width={20} height={20} />
              </button>
            </div>
          )}
          <ul className="docpro_checkmark_list">
            {filteredChildren.length > 0 ? (
              filteredChildren.map((child, index) => (
                <React.Fragment key={index}>{child}</React.Fragment>
              ))
            ) : (
              <li>No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
